import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { OverlayContextProvider } from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard/Overlay/OverlayContext';
import OrderDropdown from '../../_partials/OrderDropdown';
import BasePageLayout from '../../_partials/BasePageLayout';
import DefaultPageContent from '../../_partials/DefaultPageContent';
import s from './BrowsePage.scss';

export interface Props {
  pageType?: string;
  hasOrderSubnav?: boolean;
}

const BrowsePage: React.FC<Props> = ({ pageType, hasOrderSubnav }) => {
  const { t } = useTranslation();
  const { isLoggedIn } = useContext(SessionContext);
  const isMobile = useContext(MobileContext);

  const isMobileHomePage = isMobile && pageType === 'home';

  return (
    <OverlayContextProvider
      value={{
        // disable DD flag on anon home page which is also a DD page
        showDailyDeviationLabel: !(pageType === 'home' && !isLoggedIn),
      }}
    >
      <BasePageLayout
        title={
          isMobileHomePage
            ? undefined
            : t([`subnavigation.title.${pageType}`, 'subnavigation.title.home'])
        }
        headerRightSideContent={
          hasOrderSubnav && !isMobile && <OrderDropdown />
        }
      >
        {isMobile && (
          <div className={s['order-dropdown']}>
            <OrderDropdown />
          </div>
        )}
        <DefaultPageContent />
      </BasePageLayout>
    </OverlayContextProvider>
  );
};
BrowsePage.displayName = 'BrowsePage';

export default BrowsePage;
